import { TFunction } from "i18next";

import {
  EMPTY_VALUE_DISPLAY,
  IPassengerRowKanban,
  IRideStationPassengerRow,
  rideDragCountSelectedIds,
} from "@ryde/shared";

export const dragPassengersLabel = (
  props: IPassengerRowKanban,
  t: TFunction,
): string => {
  const { passenger, dragSelectedIds, rideDto } = props;
  const seatCount = rideDragCountSelectedIds(
    rideDto,
    dragSelectedIds,
    passenger.id,
  );

  if (seatCount < 2) {
    return `${passenger?.firstName || EMPTY_VALUE_DISPLAY} ${passenger?.lastName || EMPTY_VALUE_DISPLAY}`;
  }

  return t("ride.DRAGGING_PASSENGERS_COUNT", {
    numPassengers: seatCount,
  });
};

export const countDragPassengers = (
  props: IRideStationPassengerRow,
): number => {
  const { passenger, dragSelectedIds } = props;
  const dragPassengersCount = new Set([
    passenger.id,
    ...(dragSelectedIds || []),
  ]).size;
  return dragPassengersCount;
};
